module.exports = __webpack_public_path__ + "img/logo.7069e4d3.png";